module.exports = "/_next/static/media/541fc271871c67af7fcc593d9ca0f984.svg";